export default __webpack_public_path__ + "static/media/7.83f10f8e.png";